export default __webpack_public_path__ + "static/media/checkbox.99e8e4a8.svg";